<template>
  <div>
    <el-dialog
      top="10vh"
      width="1280px"
      center
      :title="`「${
        BankLogDialogObj.id ? BankLogDialogObj.id : ''
      }」账户流水记录`"
      :visible="BankLogDialogObj.visible"
      @close="HandleCancel"
    >
      <el-card class="filter-container" shadow="never">
        <el-row>
          <el-form :inline="true">
            <el-form-item label="区间：">
              <el-date-picker
                size="mini"
                v-model="date"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button
                icon="el-icon-search"
                type="primary"
                size="mini"
                @click="createBankCardTurnover()"
              ></el-button>
            </el-form-item>
          </el-form>
        </el-row>
      </el-card>
      <div class="table-container">
        <el-table
          border
          ref="table"
          v-loading="tableLoading"
          element-loading-background="rgba(255, 255, 255, 0.8)"
          element-loading-spinner="el-icon-loading"
          :data="returnData"
        >
          <el-table-column width="153" label="交易时间">
            <template slot-scope="scope">
              {{ scope.row.tranTime.slice(0, 4) }}-{{
                scope.row.tranTime.slice(4, 6)
              }}-{{ scope.row.tranTime.slice(6, 8) }}
              {{ scope.row.tranTime.slice(8, 10) }}:{{
                scope.row.tranTime.slice(10, 12)
              }}:{{ scope.row.tranTime.slice(-2) }}
            </template>
          </el-table-column>
          <el-table-column align="center" width="56" label="交易类型">
            <template slot-scope="scope">
              <span v-if="scope.row.transType === '1'">入账</span>
              <span v-else-if="scope.row.transType === '2'">出账</span>
              <span v-else></span>
            </template>
          </el-table-column>
          <el-table-column width="100" label="交易金额">
            <template slot-scope="scope">
              {{ scope.row.transAmount }}
            </template>
          </el-table-column>
          <el-table-column label="流水号">
            <template slot-scope="scope">
              {{ scope.row.tranTime }}-{{ scope.row.transSeqNo }}
            </template>
          </el-table-column>
          <el-table-column label="收款人信息">
            <template slot-scope="scope">
              {{ scope.row.payeeBankName }}<br />{{ scope.row.payeeBankNo
              }}<br />
              {{ scope.row.payeeName }}
            </template>
          </el-table-column>
          <el-table-column label="付款人信息">
            <template slot-scope="scope">
              {{ scope.row.payBankName ? scope.row.payBankName : "" }}<br />{{
                scope.row.payBankNo
              }}<br />
              {{ scope.row.payName }}
            </template>
          </el-table-column>
          <el-table-column width="100" label="账户余额">
            <template slot-scope="scope">
              {{ scope.row.transBalance }}
            </template>
          </el-table-column>
          <el-table-column width="150" label="其它信息">
            <template slot-scope="scope">
              {{ scope.row.transPostScript }}
              <span v-if="scope.row.businessInfo">
                - {{ scope.row.businessInfo }}
              </span>
            </template>
          </el-table-column>
          <el-table-column width="150" label="附言">
            <template slot-scope="scope"> {{ scope.row.remark }} </template>
          </el-table-column>
        </el-table>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="HandleCancel"> 关闭 </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import mainCommon from "@/utils/mainCommon";
import { createBankCardTurnover } from "@/api/bank";
export default {
  mixins: [mainCommon],
  props: ["BankLogDialogObj"],
  data() {
    return {
      date: null,
      tableLoading: false,
      listQuery: {
        startTime: "",
        endTime: "",
      },
      returnData: [],
    };
  },
  created() {
    this.HandleDateDefault(); // 给定预设日期、时间
  },
  methods: {
    // 给定预设日期、时间
    HandleDateDefault() {
      let startTime = new Date();
      let endTime = new Date();

      this.date = [
        this.HandleDateYMDFormatSeller(startTime),
        this.HandleDateYMDFormatSeller(endTime),
      ];
      this.listQuery.startTime = this.date[0];
      this.listQuery.endTime = this.date[1];
    },
    // 不需要显示时间
    HandleDateYMDFormatSeller(date) {
      let yy = date.getFullYear(),
        mm = this.HandleZero(date.getMonth() + 1, 2),
        dd = this.HandleZero(date.getDate(), 2);
      return `${yy}-${mm}-${dd}`;
    },
    createBankCardTurnover() {
      this.listQuery.accId = this.BankLogDialogObj.id;
      this.listQuery.startTime = this.date ? this.date[0] : "";
      this.listQuery.endTime = this.date ? this.date[1] : "";
      this.tableLoading = true;
      createBankCardTurnover(this.listQuery)
        .then((res) => {
          this.returnData = res.data;
        })
        .catch(() => {
          this.returnData = [];
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    HandleCancel() {
      this.returnData = [];
      this.$emit("update:bank-log-dialog-obj", { visible: false });
      this.HandleDateDefault();
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/account/code/BankLogDialog.vue